// extracted by mini-css-extract-plugin
export default {"editor":"FormMarkdownEditor-module_editor__yTsGKU","markdownEditor":"FormMarkdownEditor-module_markdownEditor__EY0yPN"};